/**
 * Custom React hook to trigger Qualtrics survey script loading.
 *
 * This hook ensures that the Qualtrics survey loader is called when the script load state changes.
 * It is typically used to manage the lifecycle of third-party survey scripts in the app.
 */
import { useEffect, useState } from 'react'
import triggerQualtricsOnLoad from 'utils/triggerQualtricsOnLoad'

/**
 * Custom React hook to trigger Qualtrics survey script loading and manage its state internally.
 * @returns {boolean} isScriptsLoaded - Whether the Qualtrics script has loaded.
 */
export function useQualtricsOnLoad(): boolean {
  const [isScriptsLoaded, setIsScriptsLoaded] = useState(false)
  useEffect(() => {
    triggerQualtricsOnLoad(isScriptsLoaded, setIsScriptsLoaded)
  }, [isScriptsLoaded])
  return isScriptsLoaded
}
